import { useEffect, useRef } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { hasPack, type CapabilityPack } from '@wapharma/domain';
import { useAuth } from '../contexts/AuthContext';
import { useToast } from '../contexts/ToastContext';

type RequirePackProps = {
  anyOf: CapabilityPack[];
};

/** SUPER_ADMIN always passes. Otherwise need at least one of `anyOf` on session packs. */
export function RequirePack({ anyOf }: RequirePackProps) {
  const { user } = useAuth();
  const { showToast } = useToast();
  const deniedRef = useRef(false);

  const roles = user?.roles ?? [];
  const packs = user?.packs;
  const allowed = Boolean(
    user && anyOf.some((pack) => hasPack(packs, roles, pack)),
  );

  useEffect(() => {
    if (user && !allowed && !deniedRef.current) {
      deniedRef.current = true;
      showToast('Accès refusé.', { tone: 'error' });
    }
  }, [allowed, showToast, user]);

  if (!user) return null;
  if (!allowed) return <Navigate to="/" replace />;
  return <Outlet />;
}
